import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const POPUP_KEY = 'zpiritualz_discount_popup_seen';
const DISCOUNT_CODE = 'WELKOM10';
const DELAY_MS = 5000;

export const DiscountPopup = () => {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const alreadySeen = localStorage.getItem(POPUP_KEY);
    if (alreadySeen) return;

    const timer = setTimeout(() => {
      setVisible(true);
    }, DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      localStorage.setItem(POPUP_KEY, 'true');
    }, 400);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(DISCOUNT_CODE).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center px-4 transition-all duration-400 ${
        closing ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ background: 'rgba(5,0,16,0.75)', backdropFilter: 'blur(6px)' }}
      onClick={handleClose}
    >
      <div
        className={`relative w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl transition-all duration-400 ${
          closing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'
        }`}
        onClick={e => e.stopPropagation()}
        style={{
          background: 'linear-gradient(135deg, #0d0025 0%, #1a0040 50%, #0d0025 100%)',
          border: '1px solid rgba(139,92,246,0.3)',
        }}
      >
        {/* Top glow bar */}
        <div className="h-1 w-full bg-gradient-to-r from-violet-500 via-fuchsia-500 to-violet-500" />

        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer rounded-full hover:bg-white/10"
          aria-label="Sluiten"
        >
          <i className="ri-close-line text-lg" />
        </button>

        {/* Background image overlay */}
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <img
            src="https://public.readdy.ai/ai/img_res/c677b42d049e86ab8523fa6473cb5e02.jpg"
            alt=""
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="relative z-10 px-8 py-8 text-center">
          {/* Icon */}
          <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-gradient-to-br from-violet-600/30 to-fuchsia-600/30 border border-violet-500/30">
            <i className="ri-gift-2-line text-3xl text-violet-300" />
          </div>

          {/* Headline */}
          <p className="text-violet-400 text-xs font-semibold tracking-[0.2em] uppercase mb-2">
            Welkom bij ZpiritualZ
          </p>
          <h2 className="text-white text-2xl md:text-3xl font-black mb-3 leading-tight">
            10% korting op je{' '}
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              eerste bestelling
            </span>
          </h2>
          <p className="text-white/60 text-sm mb-6 leading-relaxed">
            Gebruik onderstaande code bij het afrekenen en ontvang direct 10% korting op al onze spirituele beschermingsproducten.
          </p>

          {/* Discount code box */}
          <div className="flex items-center gap-3 bg-white/5 border border-violet-500/30 rounded-xl px-4 py-3 mb-6">
            <div className="flex-1 text-left">
              <p className="text-white/40 text-[10px] uppercase tracking-widest mb-0.5">Jouw kortingscode</p>
              <p className="text-white font-black text-xl tracking-[0.15em]">{DISCOUNT_CODE}</p>
            </div>
            <button
              onClick={handleCopy}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                copied
                  ? 'bg-green-500/20 text-green-400 border border-green-500/30'
                  : 'bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white hover:opacity-90'
              }`}
            >
              <i className={`text-base ${copied ? 'ri-check-line' : 'ri-file-copy-line'}`} />
              {copied ? 'Gekopieerd!' : 'Kopieer'}
            </button>
          </div>

          {/* CTA button */}
          <Link
            to="/shop"
            onClick={handleClose}
            className="block w-full py-3.5 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold text-sm rounded-xl hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line mr-2" />
            Nu winkelen met korting
          </Link>

          {/* Skip link */}
          <button
            onClick={handleClose}
            className="mt-4 text-white/30 text-xs hover:text-white/50 transition-colors cursor-pointer"
          >
            Nee bedankt, ik sla dit over
          </button>
        </div>

        {/* Bottom glow */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-violet-500/40 to-transparent" />
      </div>
    </div>
  );
};
